import React, { useCallback, useContext } from 'react';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';
import {
  selectProcessingFineTuningEnabled,
  toggleProcessingFineTuningEnabled,
} from 'app/redux/viewerConfiguration/reducer';
import { Toggle, ToggleProps } from 'rsuite';

function ProcessingFineTuningConfiguration() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const requestValidation = useContext(TechnicianPasswordValidationContext);
  const isProcessingFineTuningEnabled: boolean =
    useSelector(selectProcessingFineTuningEnabled) ?? false;

  const onChangeProcessingFineTuning: ToggleProps['onChange'] = useCallback(
    (checked, event) =>
      requestValidation()
        .then(() => dispatch(toggleProcessingFineTuningEnabled(checked)))
        .catch(() => {}),
    [dispatch, requestValidation]
  );

  return (
    <div>
      <Toggle
        checked={isProcessingFineTuningEnabled}
        size="lg"
        checkedChildren={intl.formatMessage({ id: 'general.ON' })}
        unCheckedChildren={intl.formatMessage({ id: 'general.OFF' })}
        onChange={onChangeProcessingFineTuning}
      />
    </div>
  );
}

export default React.memo(ProcessingFineTuningConfiguration);
